interface errorPageProps {
  statusCode?: number;
  jobLinks?: any;
  socialLinks?: any;
  path?: string;
  heading?: string;
  subHeading?: string;
  message?: string;
  subText?: string;
  isNotSubheading?: boolean;
  themeType?: string;
  btnText?: string;
  btnUrl?: string;
  isDesktopView?: boolean;
}
export default function errorPageProps(props: errorPageProps) {
  const {
    statusCode,
    jobLinks,
    socialLinks,
    path,
    heading,
    subHeading,
    message,
    subText,
    isNotSubheading,
    themeType,
    btnText,
    btnUrl,
    isDesktopView
  } = props;
  return {
    statusCode,
    jobLinks,
    socialLinks,
    path,
    heading,
    subHeading,
    message,
    subText,
    isNotSubheading,
    themeType,
    btnText,
    btnUrl,
    isDesktopView
  };
}
